import { gql } from '@apollo/client';

export const studentFragment = gql`
  fragment Student on Student {
    _id
    name
    email
    personalId
    addedAt
    group {
      _id
      name
    }
  }
`;
